// constants
import { LabMemberShipActionTypes } from './constants';
import { LabMemberShip as LabMemberShipData } from 'src/types/labMemberShip';

export type LabMemberShipActionType = {
    type:
        | LabMemberShipActionTypes.API_RESPONSE_SUCCESS
        | LabMemberShipActionTypes.API_RESPONSE_ERROR
        | LabMemberShipActionTypes.GET_LAB_MEMBERSHIP
        | LabMemberShipActionTypes.ADD_LAB_MEMBERSHIP
        | LabMemberShipActionTypes.EDIT_LAB_MEMBERSHIP
        | LabMemberShipActionTypes.GET_LAB_MEMBERSHIPS
        | LabMemberShipActionTypes.RESET
        | LabMemberShipActionTypes.RESET_SUCCESS
        | LabMemberShipActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const labMemberShipApiResponseSuccess = (
    actionType: string,
    data: LabMemberShipData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): LabMemberShipActionType => ({
    type: LabMemberShipActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const labMemberShipApiResponseError = (
    actionType: string,
    data: LabMemberShipData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): LabMemberShipActionType => ({
    type: LabMemberShipActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const addLabMemberShip = (params: any): LabMemberShipActionType => ({
    type: LabMemberShipActionTypes.ADD_LAB_MEMBERSHIP,
    payload: params,
});

export const editLabMemberShip = (params: any): LabMemberShipActionType => ({
    type: LabMemberShipActionTypes.EDIT_LAB_MEMBERSHIP,
    payload: params,
});

export const getLabMemberShip = (id: any): LabMemberShipActionType => ({
    type: LabMemberShipActionTypes.GET_LAB_MEMBERSHIP,
    payload: { id },
});

export const getLabMemberShips = (params: any): LabMemberShipActionType => ({
    type: LabMemberShipActionTypes.GET_LAB_MEMBERSHIPS,
    payload: params,
});

export const resetLabMemberShip = (): LabMemberShipActionType => ({
    type: LabMemberShipActionTypes.RESET,
    payload: {},
});

export const resetLabMemberShipSuccess = (): LabMemberShipActionType => ({
    type: LabMemberShipActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetLabMemberShipError = (): LabMemberShipActionType => ({
    type: LabMemberShipActionTypes.RESET_ERROR,
    payload: {},
});
